import keyBy from 'lodash/keyBy';

import { GlobalAction, VideoReactionState } from '.';

const GET_VIDEO_REACTIONS_START = 'GET_VIDEO_REACTIONS_START';
const GET_VIDEO_REACTIONS_ERROR = 'GET_VIDEO_REACTIONS_ERROR';
const GET_VIDEO_REACTIONS_SUCCESS = 'GET_VIDEO_REACTIONS_SUCCESS';
const DELETE_VIDEO_REACTION_START = 'DELETE_VIDEO_REACTION_START';
const DELETE_VIDEO_REACTION_ERROR = 'DELETE_VIDEO_REACTION_ERROR';
const DELETE_VIDEO_REACTION_SUCCESS = 'DELETE_VIDEO_REACTION_SUCCESS';

export const videoReactionReducer = (
  state: VideoReactionState,
  action: GlobalAction
): VideoReactionState => {
  const { payload, type } = action;
  switch (type) {
    case GET_VIDEO_REACTIONS_START: {
      return {
        ...state,
        loading: true,
      };
    }
    case GET_VIDEO_REACTIONS_ERROR: {
      return {
        ...state,
        loading: false,
      };
    }
    case GET_VIDEO_REACTIONS_SUCCESS: {
      return {
        ...state,
        videoReactions: keyBy(payload.videoReactions, 'reactionId'),
        loading: false,
      };
    }
    case DELETE_VIDEO_REACTION_SUCCESS: {
      const { reactionId } = payload;
      const copyState = { ...state };
      delete copyState.videoReactions[reactionId];
      return copyState;
    }
    default:
      return state;
  }
};

export const VIDEO_REACTIONS_ACTIONS = {
  GET_VIDEO_REACTIONS_START,
  GET_VIDEO_REACTIONS_ERROR,
  GET_VIDEO_REACTIONS_SUCCESS,
  DELETE_VIDEO_REACTION_START,
  DELETE_VIDEO_REACTION_ERROR,
  DELETE_VIDEO_REACTION_SUCCESS,
};
